
import React, { useEffect, useState } from "react";
import API from "./axiosInstance";

function MyOrders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user) return;

        const email = user.email;
        const res = await API.get(`/orders/user/${email}`);
        setOrders(res.data);
      } catch (err) {
        console.error("Error fetching orders:", err);
      }
    };

    fetchOrders();
  }, []);

  const formatDate = (dateString) => {
    return new Intl.DateTimeFormat("en-IN", {
      timeZone: "Asia/Kolkata",
      dateStyle: "medium",
      timeStyle: "short",
    }).format(new Date(dateString));
  };

  return (
    <div style={{ padding: "20px", maxWidth: "1000px", margin: "auto" }}>
      <h2 style={{ marginBottom: 20 }}>📦 My Orders</h2>

      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        orders.map((order) => (
          <div
            key={order.id}
            style={{
              marginBottom: "25px",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              padding: "16px",
              background: "#fff",
              boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            }}
          >
            {/* 🔵 HEADER */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <div>
                <h3 style={{ margin: 0 }}>Order #{order.id}</h3>
                <small style={{ color: "#6b7280" }}>
                  {formatDate(order.createdAt)}
                </small>
              </div>

              <span
                style={{
                  padding: "6px 12px",
                  borderRadius: "20px",
                  fontSize: "13px",
                  fontWeight: "bold",
                  background:
                    order.status === "Completed"
                      ? "#dcfce7"
                      : order.status === "Shipped"
                      ? "#e0f2fe"
                      : "#fef3c7",
                  color:
                    order.status === "Completed"
                      ? "#166534"
                      : order.status === "Shipped"
                      ? "#075985"
                      : "#92400e",
                }}
              >
                {order.status}
              </span>
            </div>

            {/* 🔵 ITEMS */}
            <div style={{ display: "grid", gap: 10 }}>
              {order.items.map((item, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    border: "1px solid #f1f5f9",
                    borderRadius: "10px",
                    padding: "10px",
                  }}
                >
                  <img
                    src={
                      item.images?.[0] ||
                      "https://res.cloudinary.com/dasyck0yn/image/upload/v1760189793/cld-sample-5.jpg"
                    }
                    alt={item.name}
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      flexShrink: 0,
                    }}
                  />

                  <div style={{ flex: 1 }}>
                    <h4 style={{ margin: "0 0 4px" }}>{item.name}</h4>
                    <p style={{ margin: 0, color: "#374151" }}>
                      ₹{item.price}
                    </p>
                    <small style={{ color: "#6b7280" }}>
                      Qty: {item.quantity || 1}
                    </small>
                  </div>
                </div>
              ))}
            </div>

            {/* 🔵 FOOTER */}
            <div
              style={{
                marginTop: 12,
                borderTop: "1px dashed #e5e7eb",
                paddingTop: 10,
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <div style={{ fontSize: "14px", color: "#374151" }}>
                <strong>Shipping:</strong> {order.name}, {order.address},{" "}
                {order.city}, {order.state} - {order.pincode}
                <br />
                <strong>Mobile:</strong> {order.mobile}
              </div>

              <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                Total: ₹{order.totalAmount}
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default MyOrders;
